import { routes } from 'routes/routes';
export const NAV_ITEMS = [
    {
        id: 'profile',
        translationKey: 'items.profile',
        route: routes.PROFILE
    },
    {
        id: 'security',
        translationKey: 'items.security',
        route: routes.SECURITY
    },
    {
        id: 'apps',
        translationKey: 'items.apps',
        route: routes.APPS
    }
];
